import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'rsuite';

const ConvertProxiesModal = ({ open, onClose, onConfirm, loading }) => (
  <Modal open={open} onClose={onClose} size="xs">
    <Modal.Header>
      <Modal.Title>Convert Proxies to Real Copies</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      This will mark all proxy entries in this deck as real, owned copies. This cannot be easily undone.
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose} appearance="subtle">
        Cancel
      </Button>
      <Button onClick={onConfirm} appearance="primary" loading={loading}>
        Convert Proxies
      </Button>
    </Modal.Footer>
  </Modal>
);

ConvertProxiesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

ConvertProxiesModal.defaultProps = {
  loading: false,
};

export default ConvertProxiesModal;
